import React from 'react';

const UserStatsCard = ({ title, tasks, colClass = 'col-4' }) => {
    return (
        <div className={`${colClass} ${colClass === 'col-4' && colClass.includes('ps-0') ? 'ps-0' : colClass === 'col-4' && colClass.includes('pe-0') ? 'pe-0' : ''}`}>
            <p className={'outer-title mt-5 mb-3'}>{title}</p>
            <div className={'box-card p-3'}>
                {
                    (tasks.users_today).length > 0 ?
                        _.map((tasks.users_today), (t, i) => (
                            <div className={'row d-flex justify-content-between'} key={i}>
                                <strong className={'col-6'}>{t.realisateur}</strong>
                                <div className={'col-6 text-end'}>
                                    <strong className={'text-white'}>{t.popups}  </strong>
                                    <span className={'text-white f-12'}> tâche{t.popups > 1 && 's'}</span>
                                </div>
                                {i + 1 !== (tasks.users_today).length && <hr className={'mt-3 mb-3'}/>}
                            </div>
                        ))
                        : <p>Pas de données pour aujourd'hui</p>
                }
            </div>
        </div>
    );
};
export default UserStatsCard;